import { Component, computed, input } from '@angular/core';
import { MatChip } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { PluralizadorPipe } from '@aionzdev/design-system';
import { PurchaseStatusDirective } from './directives/purchase-request-status.directive';
import { PurchaseRequestStatus } from '../../../enums';


@Component({
  selector: 'aionz-purchase-request-status',
  imports: [MatChip, MatIconModule, PurchaseStatusDirective],
  templateUrl: './purchase-request-status.component.html',
  styleUrl: './purchase-request-status.component.scss',
})
export class PurchaseRequestStatusComponent {
  status = input.required<PurchaseRequestStatus>();
  count = input<number | null>(null);

  private readonly pluralizador = new PluralizadorPipe();

  protected displayLabel = computed(() => {
    const count = this.count();
    if (count === null) return this.status();

    const countText = count < 10 ? `0${count}` : `${count}`;
    return `${countText} ${this.pluralizador.transform(this.status(), count)}`;
  });

  protected get icon(): string | null {
    if (this.status() === PurchaseRequestStatus.PENDING_INTEGRATION) {
      return 'warning';
    }
    return null;
  }
}
